import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const approaches = [{
  title: 'Recetas de TikTok',
  desc: "Usan ingredientes caros o 'fit' que no tienen el sabor de nuestra cocina."
}, {
  title: 'Pintar con pincel',
  desc: 'Pone demasiado aceite en un solo lugar y deja el resto pálido.'
}, {
  title: 'Temperatura de horno',
  desc: 'Cocinar a la misma temperatura que el horno tradicional es el error #1 que seca la carne por dentro.'
}, {
  title: 'Amontonar la comida',
  desc: 'Hacerlo en la canasta hace que se cocine al vapor y pierda el crocante.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    x: -20
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function FailedApproaches() {
  return <section className="bg-charcoal-light py-24 px-6 md:px-12" data-id="element-15">
      <div className="max-w-4xl mx-auto" data-id="element-16">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-17">
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-cream mb-6" data-id="element-18">
            Por qué lo que intentaste{' '}
            <span className="text-red-400" data-id="element-19">no funcionó</span>
          </h2>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-20">
          {approaches.map((item, index) => <motion.div key={index} variants={itemVariants} className="bg-charcoal p-8 rounded-2xl border border-red-900/30 flex items-start space-x-4" data-id="element-21">
              <XCircle className="text-red-400 w-8 h-8 flex-shrink-0 mt-1" data-id="element-22" />
              <div data-id="element-23">
                <h3 className="font-serif font-bold text-xl text-cream mb-2" data-id="element-24">
                  {item.title}
                </h3>
                <p className="font-sans text-cream/70 leading-relaxed" data-id="element-25">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}